import * as React from 'react';
export const ASSvg = React.forwardRef(function ASSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 4v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2Z',
      fill: '#43458B',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.108 13.665 0 8l15.108-5.665c.538.358.892.97.892 1.665v8c0 .695-.354 1.307-.892 1.665Z',
      fill: '#E25950',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.708 13.04 2.5 8l13.208-5.04c.185.303.292.659.292 1.04v8c0 .381-.107.737-.292 1.04Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.724 2.986C15.9 3.283 16 3.63 16 4v8c0 .381-.107.737-.292 1.04L15 12.776v-9.55l.708-.266.016.027Z',
      fill: '#EAEEF3',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.5 8a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
      fill: '#AA5323',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z',
      fill: '#FFC221',
    }),
  );
});
ASSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var AS = {
  category: 'flag',
  colorable: false,
  name: 'AS',
  svg: ASSvg,
};
